// UserMultiSelect.js
import React, { useEffect, useState } from "react";
import SearchableMultiSelect from "./SearchableMultiSelect";
import {
  Checkbox,
  TextField,
  FormControl,
  FormGroup,
  FormControlLabel,
  Box,
  Autocomplete,
} from "@mui/material";
import axios from "axios";
import { BASE_URL } from "../../../config/apiConfig";
import { getHeaders } from "../../../utils/apiUtils";

const UserMultiSelect = ({ setSelectedUsers, sx={}, disabled=false }) => {
  const [searchText, setSearchText] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const handleUserSelection = (event, value) => {
    setSelectedUsers((prev) => [...prev, value]);
  };
  useEffect(() => {
    fetchUsers();
  }, [searchText]); // fetch brands whenever searchText changes

  const fetchUsers = async () => {
    let headers = await getHeaders();
    try {
      const response = await axios.get(
        `${BASE_URL}tools/general/filteroptions/listall/USER?search=${searchText}`,
        headers
      );
      setUsers([
        ...new Map(response.data.data.map(user => [user.id, user])).values(),
      ]);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  return (
    <Autocomplete
      sx={{
        mb: 1,
        mt: 1,
        zIndex: 998,
        ...sx
      }}
      disabled={disabled}
      options={users}
      getOptionLabel={(option) => option.name}
      value={selectedUser}
      onInputChange={(event, newInputValue) => {
        setSearchText(newInputValue);
      }}
      onChange={handleUserSelection}
      renderInput={(params) => (
        <TextField {...params} label="Select User" variant="outlined" />
      )}
    />
  );
};

export default UserMultiSelect;
